<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user}">User</btn>
        <btn class="m-btn--column" @click.native="switchV('appointment_id')" v-bind:class="{ 'active': appointment_id }">appointment_id</btn>
        <btn class="m-btn--column" @click.native="switchV('channel_id')" v-bind:class="{ 'active': channel_id }">channel_id</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>
    <div style="display: flex">
      <button @click="postAppointment_channel" style="width: 150px"><i class="fa fa-fw fa-plus"></i></button>
      <input v-model="add.appointment_id" type="text" placeholder="appointment_id" style="border: solid 1px #ccc; width: 150px; margin: 1px; padding: 10px">
      <input v-model="add.channel_id" type="text" placeholder="channel_id" style="border: solid 1px #ccc; width: 150px; margin: 1px; padding: 10px">
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user"><td-c><input v-model="search.user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="appointment_id"><td-c><input v-model="search.appointment_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="channel_id"><td-c><input v-model="search.channel_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user"><td-c><input v-model="search.not_user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="appointment_id"><td-c><input v-model="search.not_appointment_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="channel_id"><td-c><input v-model="search.not_channel_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")' v-ripple>ID</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")' v-ripple>User</th-c></template>
          <template v-if="appointment_id"><th-c @click.native='sort("appointment_id")' v-ripple>appointment_id</th-c></template>
          <template v-if="channel_id"><th-c @click.native='sort("channel_id")' v-ripple>channel_id</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")' v-ripple>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in orderedAppointment_channels" :key="index.id">
          <template v-if="list.id == edit_id.edit_id">
            <td-c @click.native="cancelAppointment_channel(list)" class="del" style="position: relative">戻る</td-c>
            <td-c @click.native="patchAppointment_channel(list)" class="del" style="position: relative">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="appointment_id"><td-c style="border: solid 3px #41B883"><input type="text" v-model="list.appointment_id" style="font-weight: bold"></td-c></template>
            <template v-if="channel_id"><td-c style="border: solid 3px #41B883"><input type="text" v-model="list.channel_id" style="font-weight: bold"></td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteAppointment_channel(list)" class="del" style="position: relative">削除</td-c>
            <td-c @click.native="editAppointment_channel(list)" class="del" style="position: relative">編集</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="appointment_id"><td-c>{{list.appointment_id}}</td-c></template>
            <template v-if="channel_id"><td-c>{{list.channel_id}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/appointment_channels/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'appointment_channel',
  pageNames: 'appointment_channels'
}

let _ = window._
export default {
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      asc: '',
      desc: '',
      sortState: '',

      id: false,
      user: false,
      appointment_id: true,
      channel_id: true,
      created_at: false,

      search: {
        id: '',
        user: '',
        name: '',
        appointment_id: '',
        channel_id: '',
        created_at: '',
        not_id: '',
        not_user: '',
        not_name: '',
        not_appointment_id: '',
        not_channel_id: '',
        not_created_at: ''
      },

      add: {
        name: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    appointment_channels () {
      return this.$store.getters.appointment_channels
    },

    orderedAppointment_channels () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.appointment_channels, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.appointment_channels, this.desc).reverse()
      }
    }
  },
  methods: {
    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.user = false
      this.appointment_id = false
      this.channel_id = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.user = true
      this.appointment_id = true
      this.channel_id = true
      this.created_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    editAppointment_channel (list) {
      this.edit_id.edit_id = list.id
    },

    postAppointment_channel () {
      this.$store.dispatch('postAppointment_channel', this.add)
    },

    deleteAppointment_channel (list) {
      this.$store.dispatch('deleteAppointment_channel', list)
    },

    cancelAppointment_channel (list) {
      this.$store.dispatch('cancelAppointment_channel', {
        list: list,
        edit_id: this.edit_id
      })
    },

    patchAppointment_channel (list) {
      this.$store.dispatch('patchAppointment_channel', {
        list: list,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
  font-size: 12px;
}
.index-box {
  height: calc(100vh - 190px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// Appointment_channelsIndex.vue?08f93c04